import axios from 'axios';
import customAxios from '../../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../../scss/Components/_modal.scss"
import { GlobalVariables } from '../../../../globalVar';
import { toast } from 'react-toastify';
import { getToast } from '../../../../utils/toastConfig';

function ModalEMultDelete(props) {
    let idList = []
    let equipDeleteList = localStorage.getItem("equipMultipleDeleteList");
    if (equipDeleteList !== null && equipDeleteList !== undefined) {
        idList = equipDeleteList.replace(/\[|\]|\'/g, '').split(',').map(Number);
    }

    const deleteEquips = () => {
        customAxios.patch(`${GlobalVariables.getURL()}multipleDeleteEquip`, { idList }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(response => {
            console.log(response.data);
            hideS();
        })
        .catch(error => {
            console.error(error);
            getToast({ status: 'error', title: 'Error al eliminar tipo(s) de equipo. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Tipo(s) de equipo eliminado(s) exitosamente en la base de datos.' });
        props.getEquips();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    ¿Quieres borrar estos tipos de equipos?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {idList.map(id => <span><strong>ID del Tipo de equipo:</strong> {id}<br/></span>)}
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteEquips()}}><FontAwesomeIcon icon={faWarning}/> Si, quiero eliminar esto.</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> No, regrésame a la tabla.</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalEMultDelete;